import { render, staticRenderFns } from "./NetworkIssue.vue?vue&type=template&id=bafc41f6&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bafc41f6')) {
      api.createRecord('bafc41f6', component.options)
    } else {
      api.reload('bafc41f6', component.options)
    }
    module.hot.accept("./NetworkIssue.vue?vue&type=template&id=bafc41f6&", function () {
      api.rerender('bafc41f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NetworkIssue.vue"
export default component.exports